<template lang="">
    <div>
        <img v-if="hasImage" class='fondo1 rounded mx-auto d-block' :src="imagen"/>
        <h2>{{getTitulo}}</h2>
       
        <data-values :client="client" v-if="subscribeSuccess" @edit="edit" :datosTratados="datosTratados"></data-values>
        <div v-else>Esperando a recibir datos...</div>
    </div>
</template>
<script>
import DataValues from './DataValues.vue'
export default {
    components: {
        DataValues,
    },
    props: {
        id: {
            type: Number,
        },
        datos:Object,
        subscribeSuccess:Boolean,
        client: Object
    },
    mounted () {
       console.log("Zona detalle montada")
    },
    data() {
        return {
            hasImage: false,
            
        }
    },
    computed: {
        getTitulo(){
            let res='?'
            switch (this.id) {
                case 2:
                    res='BARRENADO'
                    break;
                case 4:
                    res='TRANSFORMADORES'
                    break;
                case 5:
                    res='EVAPORATIVO'
                    break;
                case 6:
                    res='MANTENIMIENTO'
                    break;
                case 7:
                    res='POZO'
                    break; 
                case 8:
                    res='Grupo contra incendios'
                    break; 
                case 9:
                    res='GREENTECH'
                    break;
                case 10:
                    res='COMPRESORES'
                    break;
                case 11:
                    res='HORNOS'
                    break;
                case 12:
                    res='FILTRO PRENSA'
                    break;
            
                default:
                    res='?'
                    break;
            }
            return res
        },
        datosTratados(){
            let result=[];
            let indice=0;
            for (let [key, value] of Object.entries(this.datos)) {
                let tipoDato='';
                let topic_escritura ='';
                //console.log(key,value);
                let fValue = parseFloat(value);
               

                if(key.includes('#TRIESTADO')){
                    //value=3;
                    fValue=value;
                    tipoDato='TRIESTADO';
                    console.log("El valor esssssss")
                    console.log(value);
                    key=key.replace('#TRIESTADO','');

                }else{
                    if(key.includes('#VIGILAR')){
                        key=key.replace('#VIGILAR','');
                        tipoDato='VIGILAR';
                    }else{
                        if(typeof(value)==='boolean'){
                        tipoDato='BOOLEAN';
                    }
                    else {
                        tipoDato='REAL';
                    }
                    
                    if(Number.isNaN(fValue))fValue=value;
                    else fValue=fValue.toFixed(1)
                    }
                }
                let ignorar=false;
                if (key.includes("@")){
                    const splited = key.split("@")
                    //console.log("Espliteado", splited)
                    tipoDato=`ESCRITURA_${splited[2]}`
                    const todos = key.split("@")
                    key = todos[todos.length-1]
                    topic_escritura=todos[todos.length-2]
                    //ignorar=true;
                   //console.log("CLARO QUE TIENE ARROBA!!!")
                }


                // console.log(`${key}: ${value}`);
                
                if(this.esMostrable(indice)){
                    if(!ignorar){
                        result.push({
                            'variable':key,
                            'valor':fValue,
                            'tipo':tipoDato,
                            'topic_escritura':topic_escritura
                        })
                    }
                }
                
                indice++;
            }

            return result;

        },
       
        imagen() {
            let res='';
            switch (this.id) {
                case 1://Zona centrifugacion
                    this.hasImage=true;
                    res = require("@/assets/centrifugacion.png");
                    // res = "/img/planta2.png";
                    break;
                case 2://Zona centrifugacion
                    this.hasImage=true;
                    res = require("@/assets/barrenado.png");
                    // res = "/img/planta2.png";
                    break; 
                case 4://Zona centrifugacion
                    this.hasImage=false;
                   
                    break;
            
                default:
                    break;
            }
            return res;
        }
    },
    methods: {
        edit(payload){
            console.log(payload)
            console.log(this.datos)
            payload.item.isEditing=true;
            this.datos[payload.index].isEditing=true;
            this.datos.splice();
            console.group("datos tratados")
            console.log(this.datosTratados)
            console.groupEnd()
        },
        mostrarIframe(q,ruta) {
           
            if(q) window.open(ruta,'_blank','fullscreen="no"')
            
        },
        tieneAlarma(i){
             return (i)? require("@/assets/rojo.png"):require("@/assets/transparente.png");
        },
        esMostrable(indice){
            let excepcion=[]

            switch (this.id) {
                case 6://mantenimiento
                    excepcion=[0,1,3,4]
                    break; 
                case 2://barrenado
                    excepcion=[0,1]
                    break;
                case 7://pozo
                    // if([0,1,3] in indice)resultado=false;
                    excepcion=[0,1,3]
                    break;
                case 5://evaporativo
                    // if([0,1] in (indice))resultado=false;
                    excepcion=[0,1]
                    break;
                case 8://incendios
                    // if([0,1] in (indice))resultado=false;
                    excepcion=[0]
                    break;
                
                case 12://incendios
                    // if([0,1] in (indice))resultado=false;
                    excepcion=[0]
                    break;
            
                default:
                    break;
            }
            return !excepcion.includes(indice)
        }
    },
   
    
}
</script>
<style >
    .fondo1 {
       display: block;
        margin-left: auto;
        margin-right: auto;
        width: 45%;
    }
</style>